import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import {useSelector} from "react-redux";
import {Link} from "react-router-dom";
import {useState} from "react";

//Calendar for assigning jobs to installers
export function InstallationCalendarMonthView(props) {

    const eventList = useSelector((state) => state.installerListVehicleEvents);
    const [errorMessage, setErrorMessage] = useState(null);
    const handleDateClick = (info) => {
        const selectedDate = new Date(info.dateStr);
        const today = new Date();
        today.setDate(today.getDate() - 1);
        if (selectedDate < today) {
            setErrorMessage("Cannot select a date in the past.");
        } else {
            setErrorMessage(null);
            props.onDateClick(info.dateStr);
        }
    }

    return (
        <div id="calendar-container" className="page-section detail-container">
            <div className="container installer-header calendar-header">
                <Link to="/installation/unassigned" className="back-button-link">
                    <button className="btn btn-secondary back-button">
                        <span className="back-button-arrow"></span> Back
                    </button>
                </Link>
                <h2 className="time-title">Select Time Slot</h2>
            </div>
            {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}
            <div className="calendar-container">
                <FullCalendar
                    plugins={[dayGridPlugin, interactionPlugin]}
                    initialView={'dayGridMonth'}
                    headerToolbar={{start: 'prev', center: 'title', end: 'next'}}
                    contentHeight="auto"
                    businessHours={[{
                        daysOfWeek: [1, 2, 3, 4, 5],
                        startTime: '7:00',
                        endTime: '16:00'
                    }, {daysOfWeek: [6], startTime: '7:00', endTime: '13:00'}]}
                    dateClick={handleDateClick}
                    events={eventList}
                />
            </div>
        </div>
    );
}
